import ScrollDirection from "./ScrollDirection";

const $ = window.jQuery;
const $window = window.$window || $(window);
const window_height = $window.height();
const ScrollMonitor = require('scrollmonitor');

const Toc = {

    $current: null,
    watched_items: [],

    init() {
        var $module = $('.TocAnchor');
        if (!$module.length)
            return;

        // todo - if TOC isn't visible, don't do anything here.

        ScrollDirection.init();

        $module.each((index, element) => {
            this.each(element);
        });

    },

    each(element) {

        let $element = $(element);
        let offset = (window_height - $element.height()) / 2;
        let watched = ScrollMonitor.create(element, offset);
        let index = this.watched_items.length;

        this.watched_items.push(watched);

        watched.stateChange(() => {
            //console.log('isInViewport: ' + watched.isInViewport + ', isFullyInViewport: ' + watched.isFullyInViewport + ', isAboveViewport: ' + watched.isAboveViewport + ', isBelowViewport: ' + watched.isBelowViewport + ', scrollDirection: ' + this.scroll_direction);
            if (watched.partiallyExitViewport && watched.isInViewport && watched.isAboveViewport && ScrollDirection.is_down()) {
                this.set_current(element);
                //console.log('SETTING CURRENT ON #' + $element.attr('id'));

            } else if (watched.partiallyExitViewport && watched.isInViewport && watched.isBelowViewport && !watched.isAboveViewport && ScrollDirection.is_up()) {
                // Get the next one up and set that.
                //console.log('SETTING PREVIOUS ON #' + $element.attr('id'));
                if (this.watched_items[index - 1]) {
                    this.set_current(this.watched_items[index - 1].watchItem);
                }
            }

        });

    },

    set_current(element) {
        if (this.$current) {
            this.$current.removeClass(this.$current.data('active-class'));
        }

        let $link = $('#TocLink--' + element.getAttribute('id'));
        this.$current = $link.addClass($link.data('active-class'));
    }

};

export default Toc;